import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-facility',
  templateUrl: './add-facility.component.html',
  styleUrls: ['./add-facility.component.scss']
})
export class AddFacilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Output() CloseAddfacility = new EventEmitter<boolean>()

  CloseSchedule(message) {
    this.CloseAddfacility.emit(message);   
  }

}
